export default __webpack_public_path__ + "static/media/fmExPlaceholder.5c237f08.png";